import { useAuthStore } from '@/store/auth';
import { useMasters } from '@/lib/queries';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Users } from 'lucide-react';

export const ScopeSwitcher = () => {
  const { master, scope, setScope } = useAuthStore();
  const { data: masters } = useMasters();
  if (!master || master.role !== 'owner') return null;

  return (
    <Select value={scope} onValueChange={(v) => setScope(v)}>
      <SelectTrigger className="h-9 w-auto gap-2 rounded-full border-border/60 bg-card px-3 text-xs font-semibold shadow-soft">
        <Users className="h-3.5 w-3.5 text-primary" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="me">Я</SelectItem>
        <SelectItem value="worker">Работники</SelectItem>
        <SelectItem value="all">Все</SelectItem>
        {(masters ?? [])
          .filter((m: any) => m.id !== master.id)
          .map((m: any) => (
            <SelectItem key={m.id} value={m.id}>
              {m.name}
            </SelectItem>
          ))}
      </SelectContent>
    </Select>
  );
};
